/* PX scroll-scrub engine — ported from prototype px.js (prototype-v1-client-review).
   One engine, N section instances; init is order-independent (config from data attrs).
   Frames: Shopify Files CDN, flat scheme px_{pid}_{d|m}_{NNNN}.webp (see repo README). */

(function () {
  'use strict';

  var IS_MOBILE = matchMedia('(max-width: 767px)').matches;
  var REDUCED = matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initSection(section) {
    var cfg = {
      base: section.dataset.frameBase.replace(/\/$/, ''),
      pid: section.dataset.framePrefix,
      frames: parseInt(IS_MOBILE ? section.dataset.framesMobile : section.dataset.framesDesktop, 10),
      boundary: parseInt(IS_MOBILE ? section.dataset.boundaryMobile : section.dataset.boundaryDesktop, 10),
      dim: IS_MOBILE ? 900 : 1440,
      setChar: IS_MOBILE ? 'm' : 'd',
    };
    var canvas = section.querySelector('canvas');
    canvas.width = cfg.dim;
    canvas.height = cfg.dim;
    var ctx = canvas.getContext('2d');
    var loadwrap = section.querySelector('.px-loadwrap');
    var loadbar = section.querySelector('.px-loadbar i');
    var co1 = section.querySelector('.px-callout.b1');
    var co2 = section.querySelector('.px-callout.b2');

    /* Faded callout's CTA must leave the tab order (it's opacity:0 but in the DOM) */
    function setCallout(el, on) {
      el.classList.toggle('active', on);
      var cta = el.querySelector('.px-co-cta');
      if (cta) cta.tabIndex = on ? 0 : -1;
    }

    var pad = function (i) { return String(i).padStart(4, '0'); };
    var url = function (i) {
      return cfg.base + '/' + cfg.pid + '_' + cfg.setChar + '_' + pad(i) + '.webp';
    };

    /* reduced motion: static end-frame, no pin, no preload army */
    if (REDUCED || !window.gsap || !window.ScrollTrigger) {
      section.classList.add('px-static');
      var last = new Image();
      last.onload = function () {
        ctx.drawImage(last, 0, 0, cfg.dim, cfg.dim);
        loadwrap.classList.add('done');
      };
      last.src = url(cfg.frames);
      setCallout(co1, false);
      setCallout(co2, true);
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    var images = new Array(cfg.frames + 1);
    var loaded = 0, started = false, booted = false;

    function drawFrame(i) {
      var img = images[i];
      if (img && img.complete && img.naturalWidth) ctx.drawImage(img, 0, 0, cfg.dim, cfg.dim);
    }

    function boot() {
      if (booted) return;
      booted = true;
      loadwrap.classList.add('done');
      drawFrame(1);
      var state = { frame: 1 };
      gsap.to(state, {
        frame: cfg.frames,
        ease: 'none',
        scrollTrigger: {
          trigger: section,
          start: 'top top',
          end: 'bottom bottom',
          scrub: 0.15,
          onUpdate: function () {
            var f = Math.max(1, Math.min(cfg.frames, Math.round(state.frame)));
            drawFrame(f);
            var inB2 = f >= cfg.boundary;
            setCallout(co1, !inB2);
            setCallout(co2, inB2);
          },
        },
      });
    }

    function startLoading() {
      if (started) return;
      started = true;
      for (var i = 1; i <= cfg.frames; i++) {
        (function (i) {
          var im = new Image();
          im.src = url(i);
          im.onload = im.onerror = function () {
            loaded++;
            loadbar.style.width = (loaded / cfg.frames) * 100 + '%';
            if (loaded === cfg.frames) boot();
          };
          images[i] = im;
        })(i);
      }
    }

    new IntersectionObserver(function (entries, obs) {
      if (entries.some(function (e) { return e.isIntersecting; })) {
        startLoading();
        obs.disconnect();
      }
    }, { rootMargin: '150% 0px' }).observe(section);
  }

  function initAll() {
    document.querySelectorAll('.px-scrub[data-frame-base]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
